import {BaseWidgetSettings} from "./base-settings.type";
import {IBaseNavbarData, IBaseNavbarDesign} from "../../structural";
import {ComponentVariant} from "./component-variants";

export type NavbarWidgetSettings = {
  variant?: ComponentVariant;
  navbarData?: IBaseNavbarData;
  navbarDesign?: IBaseNavbarDesign;
} & BaseWidgetSettings;
